import React, { Component } from 'react'
import {
    Link
  } from 'react-router-dom';

  const ChildComponent = ({ name }) => {
    // Use the stateVariable in this component
  }

class Header extends Component  { 

  render() {
    debugger;
    
    const currentPath = window.location.pathname;
    const requestID = this.props.requestID;
    const clientID = this.props.clientID;
    const payeeEmail = this.props.payeeEmail;
    const name = this.props.entityName;
    const payeeName = this.props.payeeName;
  
    return (
      <>
        <div className="container-scroller">
    <div className="horizontal-menu">
       <nav className="navbar top-navbar col-lg-12 col-12 p-0">
        <div className="container">
          <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
            <a className="navbar-brand brand-logo" href="https://ascendant.world/" target='_blank'><img src="assets/images/afxlogo.png" alt="logo"/></a>
            <a className="navbar-brand brand-logo-mini" href="https://ascendant.world/" target='_blank'><img src="assets/images/logo-mini.png" alt="logo"/></a>
          </div>
          <div className="navbar-menu-wrapper d-flex align-items-center justify-content-end">
            
            <ul className="navbar-nav navbar-nav-right">
              <li className="nav-item count-indicator nav-profile dropdown">
                <a className="nav-link  dropdown-toggle" href="#" data-toggle="dropdown" id="profileDropdown">
                  <span className="nav-profile-name">{name}</span>                  
                </a>                
              </li>             
           
            </ul>
           
          </div>
        </div>
      </nav>
      <nav className="bottom-navbar">
        <div className="container">
          <ul className="nav page-navigation">
            
            <li className="nav-item">
              <Link className="nav-link" to={{
                           pathname: '/Dashboard',
                            state: {                             
                              requestID: requestID,
                              payeeName:payeeName,
                              entityName: name,
                              clientID: clientID,
                              payeeEmail: payeeEmail
                          }                          
                        }} >
                <i className="mdi mdi-bank menu-icon"></i>
                <span className="menu-title">Dashboard</span>
              </Link>
            </li>            
            {/* {!currentPath.includes('Managebankaccount')?
            <li className="nav-item">
              <Link className="nav-link" to="/Addbankaccount">
                <i className="mdi mdi-clipboard-plus menu-icon"></i>
                <span className="menu-title">Add Bank Account</span>
              </Link>
            </li>
            : '' } */}

            {/* <li className="nav-item">
              <Link className="nav-link" to="Supportlist">
                <i className="mdi mdi-help-network menu-icon"></i>
                <span className="menu-title">Support</span>
              </Link>
            </li> */}

            <li className="nav-item">
              &nbsp;
            </li>
            <li className="nav-item">
              &nbsp;
            </li>


            <li className="nav-item">
              &nbsp;
            </li>

            <li className="nav-item">
              &nbsp;
            </li>
            <li className="nav-item">
              &nbsp;
            </li>
            <li className="nav-item">
              &nbsp;
            </li>
            
            <li className="nav-item">
              {/* <Link to="/Logout" target="_blank" className="nav-link">
                <i className="mdi mdi-logout menu-icon"></i>
                <span className="menu-title">Logout</span></Link>  */}

                 <Link className="nav-link" to={{
                           pathname: '/Logout',
                            state: { 
                              payeeEmail:localStorage.getItem('payeeEmail')                          
                          }                          
                        }} >
                <i className="mdi mdi-logout menu-icon"></i>
                <span className="menu-title">Logout</span>
              </Link>               
            </li>
          </ul>
        </div>
      </nav>
    </div>
    </div>
      </>
    )
  }
}

export default Header
